// src/modules/operations/dashboard/widgets/shells/AllocationsByStatusChart.tsx
import { useQuery } from "@tanstack/react-query";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
} from "recharts";
import { Layers } from "lucide-react";
import { apiFetch } from "@/modules/shared/lib/api-client";

type Funnel = { stages: { stage: string; count: number }[] };

const STATUS_LABEL: Record<string, string> = {
  active: "Ativa",
  paused: "Pausada",
  ended: "Encerrada",
  inactive: "Inativa",
  pending: "Pendente",
  cancelled: "Cancelada",
  // Health-state values that leak into allocations.status:
  critical: "Crítica",
  warning: "Atenção",
  healthy: "Saudável",
};

export function AllocationsByStatusChart() {
  const { data } = useQuery<Funnel>({
    queryKey: ["widget", "/operations/dashboard/allocations-by-status"],
    queryFn: () => apiFetch<Funnel>("/operations/dashboard/allocations-by-status"),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });

  const chartData = (data?.stages ?? []).map((s) => ({
    ...s,
    label: STATUS_LABEL[s.stage] ?? s.stage,
  }));

  return (
    <div className="ol-card flat col-span-2 flex flex-col gap-3">
      <div className="ol-card-head">
        <div className="ol-card-ic ink"><Layers /></div>
        <div className="ol-card-title">
          <div className="ol-card-name"><span className="n">Alocações por status</span></div>
        </div>
      </div>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="label" tick={{ fill: "#6b716b", fontSize: 11 }} />
            <YAxis allowDecimals={false} tick={{ fill: "#6b716b", fontSize: 11 }} />
            <Tooltip />
            <Bar dataKey="count" fill="#c6f04c" stroke="#0b0d0b" strokeWidth={1} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
